import { ApiClient } from "@common/network/client";
import { IApiClient } from "@common/network/interfaces";
import { getConfig } from "@config/index";
const ENDPOINTS = {
  fetchAddressByPincodeAPI: `https://api.postalpincode.in/pincode/`,
  fetchCountry: () => `api/form-service/public/v1/countries`,
  fetchState: () => `api/form-service/public/v1/states/`,
  fetchCity: () => `api/form-service/public/v1/cities/`,
};
class CommonRepository {
  private apiClient: IApiClient;
  constructor(apiClient: IApiClient) {
    this.apiClient = apiClient;
  }

  public fetchAddressByPincode = async (pincode: string) => {
    const result = await fetch(ENDPOINTS.fetchAddressByPincodeAPI + pincode, {
      method: "GET",
    });
    const response = await result.json();
    return response[0];
    // const result = await this.apiClient.get(ENDPOINTS.fetchAddressByPincodeAPI() + pincode,{}, {
    //   baseURL:  config.PIN_CODE_BASE_URL,
    // });
    // const response = await result.json();
  };

  public fetchDataFromDynamicUrl = async (payload: {
    baseUrl: string;
    urlEndpoint: string;
  }) => {
    const { baseUrl, urlEndpoint } = payload;
    const result = await this.apiClient.get(
      urlEndpoint,
      {},
      {
        baseURL: baseUrl,
        disableEnvelope: true,
      }
    );
    return result.data;
  };

  public fetchCountry = async () => {
    const result = await this.apiClient.get(
      ENDPOINTS.fetchCountry(),
      {},
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return result.data;
  };

  public fetchState = async (country: string) => {
    const result = await this.apiClient.get(
      ENDPOINTS.fetchState() + `${country}`,
      {},
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return result.data;
  };

  public fetchCity = async (city: string, country: string) => {
    const result = await this.apiClient.get(
      ENDPOINTS.fetchCity() + `${country}/` + `${city}`,
      {},
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return result.data;
  };
}

const commonRepository = new CommonRepository(ApiClient);

export { commonRepository as CommonRepository };
